export default "__VITE_PUBLIC_ASSET__80b84f1e__"